import { Delete } from '@mui/icons-material';
import { Box, IconButton, TableCell, Typography } from '@mui/material';
import CustomTextField from 'components/atom/CustomTextField';
import React, { forwardRef, useState } from 'react';
import { toCamelCase } from '../services';

const StructureForm = (props) => {
    const { column, columns, render: mainRender, index, rows, stateRef, config = {} } = props;
    const [_, forceUpdate] = useState({});
    const render = () => forceUpdate({});

    const value = column?.name ?? "";

    const checkUniqueNamePresent = (uniqueName) =>
        columns.some((col) => col?.uniqueName === uniqueName);

    const generateUniqueNameWithPrefix = (baseName) => {
        let i = 0;
        let candidate = baseName;
        while (checkUniqueNamePresent(candidate)) {
            candidate = `${baseName}${++i}`;
        }
        return candidate;
    };

    const handleDelete = (deleteIndex) => {
        const updatedColumns = columns.filter((_, i) => i !== deleteIndex);
        columns.splice(0, columns.length, ...updatedColumns);
        const uniqueName = column?.uniqueName;
        if (uniqueName && rows?.[uniqueName] !== undefined) {
            delete rows[uniqueName];
        }
        mainRender();
    };

    const updateTrackchanges = () => {
        const key = column?.isNew ? "uuid" : "uniqueName"
        stateRef.current.trackColumnChanges = [
            ...stateRef.current.trackColumnChanges.filter(col => col?.[key] !== column?.[key]),
            column
        ]
    }

    const handleChange = (newValue) => {
        column.name = newValue;

        if (column?.isNew) {
            const prevUniqueName = column?.uniqueName;
            let newUniqueName = toCamelCase(newValue);
            if (!newUniqueName) {
                newUniqueName = generateUniqueNameWithPrefix("column");
            }
            if (checkUniqueNamePresent(newUniqueName) && newUniqueName !== prevUniqueName) {
                newUniqueName = generateUniqueNameWithPrefix(newUniqueName);
            }
            column.uniqueName = newUniqueName;
            if (prevUniqueName && rows?.[prevUniqueName] !== undefined) {
                rows[newUniqueName] = rows[prevUniqueName];
                delete rows[prevUniqueName];
            }
        }
        updateTrackchanges()
        render();
    };

    return (
        <TableCell>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "20px",
                }}
            >
                <Typography>{index + 1}</Typography>

                {!!config?.onDelete !== false && !!config?.onDelete?.isVisible && <IconButton
                    color="error"
                    onClick={() => handleDelete(index)}
                    disabled={!config?.onDelete?.isActive}
                >
                    <Delete />
                </IconButton>}

                <CustomTextField
                    value={value}
                    placeholder="Enter column name"
                    onChange={(e) => handleChange(e?.target?.value)}
                />
            </Box>
        </TableCell>
    );
};

const WrappedStructureForm = forwardRef(StructureForm);
WrappedStructureForm.__IS_DYNAMIC_TABLE__ = true;


export default WrappedStructureForm;
